// extracted by mini-css-extract-plugin
export var button = "_my-2";
export var card = "_my-0";
export var closeButtonContainer = "_my-3";
export var iconContainer = "_my-1";